import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const SiteCtx = createContext({ site: { site_name: "Laxmiwin" }, reloadSite: () => {} });

export function SiteProvider({ children }) {
  const [site, setSite] = useState({ site_name: "Laxmiwin" });
  const reloadSite = useCallback(() => api.get("/settings").then(r => setSite(r.data)).catch(() => {}), []);
  useEffect(() => { reloadSite(); }, [reloadSite]);
  useEffect(() => { document.title = site.site_name || "Laxmiwin"; }, [site.site_name]);
  return <SiteCtx.Provider value={{ site, setSite, reloadSite }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
